import { render, staticRenderFns } from "./AddOrEditPortalUsers.vue?vue&type=template&id=be811ecc&"
import script from "./AddOrEditPortalUsers.vue?vue&type=script&lang=ts&"
export * from "./AddOrEditPortalUsers.vue?vue&type=script&lang=ts&"
import style0 from "./AddOrEditPortalUsers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports